export default __webpack_public_path__ + "static/media/default-challenge-image.5be7255e.jpg";